import { render, staticRenderFns } from "./AddVehicle.vue?vue&type=template&id=5d7aca04&scoped=true"
import script from "./AddVehicle.vue?vue&type=script&lang=js"
export * from "./AddVehicle.vue?vue&type=script&lang=js"
import style0 from "./AddVehicle.vue?vue&type=style&index=0&id=5d7aca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7aca04",
  null
  
)

export default component.exports